import React from 'react'
import { useContainerWidth } from '@fs/zion-ui'
import CollapsedNavLinks from './CollapsedNavLinks'
import FullNavLinks from './FullNavLinks'

export default function NavLinks({ nonReligiousMode, canSeeTemple, external }) {
  const atWidth = useContainerWidth()

  return (
    <div>
      {atWidth({
        default: (
          <CollapsedNavLinks nonReligiousMode={nonReligiousMode} canSeeTemple={canSeeTemple} external={external} />
        ),
        xl: <FullNavLinks nonReligiousMode={nonReligiousMode} canSeeTemple={canSeeTemple} external={external} />,
      })}
    </div>
  )
}
